import { render, staticRenderFns } from "./dealerInsert.vue?vue&type=template&id=405083b0&"
import script from "./dealerInsert.vue?vue&type=script&lang=js&"
export * from "./dealerInsert.vue?vue&type=script&lang=js&"
import style0 from "./dealerInsert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports